/**
 * Methods to update the layout and its content
 */
define('layout',['require','utils','olarkUtils','services/browsapowa','ractivejs','services/userService','rv!templates/layout/menu','rv!templates/layout/ribbon','rv!templates/layout/footer','controllers/retargetingpixel','rv!templates/partials/breadcrumbs'],function (require) {
    'use strict';
    var utils = require('utils');
    var olarkUtils = require('olarkUtils');
    var browsapowa = require('services/browsapowa');
    var Ractive = require('ractivejs');
    var userService = require('services/userService');
    return {
        /**
         * probably should just make a prototypical object...
         */
        construct: function () {
            this.retryCount = 0;
            this.onServerDataLoadedHandler = this.onServerDataLoaded.bind(this);
            this.onServerDataErrorHandler = this.onServerDataError.bind(this);
            this.content = $('#layout-content');
        },

        /**
         * Upon DOM load, Setup layout client-side data
         */
        init: function () {
            this.initGlobalHandlers();
            $('body').show();
            olarkUtils.init();
            this._injectAiWidgets();
            this.setOptimizely();
            browsapowa.oldBrowserWarning();
        },

        /**
         * Inject the AI Concierge scripts GLOBALLY (Bug #13).
         *
         * WHY here: layout.init() runs once on every page load regardless of
         * which master/route renders the page — the same place olarkUtils.init()
         * lives. The chat previously loaded from home.html's inline injector, so
         * it only existed on the home route and vanished on refresh/navigation
         * to any other page (e.g. #/hotel-new-search). Moving it here makes the
         * chat persist everywhere.
         *
         * These are plain self-executing scripts (NOT require.js modules), so we
         * inject <script> tags like home.html did. ai-chat.js injects its own
         * DOM and is idempotent; ai-popup-avatar self-gates on the voice toggle.
         * We guard with a flag so re-entrant init() calls don't double-load.
         */
        _injectAiWidgets: function () {
            if (window._aiWidgetsInjected) return;
            window._aiWidgetsInjected = true;

            // #90: version each asset by its server-side last-write time
            // (window._aiAssetVer, emitted by Adest_Main_Resources.master.vb).
            // Static files are cached for 365 days, and the fixed ?v= numbers
            // below were never bumped when the files changed, so browsers kept
            // running old code. The fixed numbers are only a fallback.
            //
            // #95 (boss testing 10-01): the cancel card was still in the old
            // three-column layout on My Vacations, and stacked correctly on the
            // cancellation page. _aiAssetVer only exists on .aspx pages (the
            // master page writes it); the single-page site (index.html) has none,
            // so every SPA page fell back to ai-booking-engine.js?v=28 etc. — a
            // copy each browser had cached for a year. On the SPA, version by the
            // deploy's site version instead (ServerData is loaded before init()
            // runs here, and every deploy's build stamps a new one).
            var assetVer = window._aiAssetVer || {};
            var siteVer = '';
            try {
                siteVer = (window.ServerData && window.ServerData.Settings && window.ServerData.Settings.SiteVersion) || '';
                if (!siteVer && window.requirejs && window.requirejs.s) {
                    siteVer = String(window.requirejs.s.contexts._.config.urlArgs || '').replace(/^sv=/, '');
                }
            } catch (e) { siteVer = ''; }
            var versioned = function (path, fallback) {
                return path + '?v=' + (assetVer[path] || siteVer || fallback);
            };
            // Injected scripts are async by default and would run in whatever
            // order they finish downloading; async=false keeps insertion order
            // (chat → booking engine → avatar), which the engine relies on.
            var addScript = function (src) {
                var s = document.createElement('script');
                s.src = src;
                s.async = false;
                document.head.appendChild(s);
            };

            // Chat widget styles + logic. Loaded BEFORE the booking engine so
            // the chat DOM (#ai-chat-messages, etc.) exists when the booking
            // engine wires its handlers (Bugs #9, #13, #17).
            var chatCss = document.createElement('link');
            chatCss.rel = 'stylesheet';
            chatCss.type = 'text/css';
            chatCss.href = versioned('/fe/css/ai-chat.css', '2');
            document.head.appendChild(chatCss);

            addScript(versioned('/fe/js/ai-chat.js', '3'));
            console.log('[AI] Chat widget script injected (global)');

            addScript(versioned('/fe/js/ai-booking-engine.js', '28'));
            console.log('[AI] Booking engine script injected (global)');

            // Voice/Video avatar overlay. Self-gates on the voice toggle
            // (set by checkAiStatus after fetching /public/ai-status). Loading
            // unconditionally is safe — when OFF, boot() exits without showing
            // or connecting anything, so an admin flipping it ON mid-session
            // works without a page reload.
            addScript(versioned('/fe/js/ai-popup-avatar.js', '9'));
            console.log('[AI] Popup avatar script injected (global)');
        },

        setLayout: function () {
            this.setRibbon();
            this.setMenu();
            this.setFooter();
        },

        /**
         * Lazily-loads information about the logged in user and other common server-side data.
         * If the site version has changed, we reload the page to get the latest version of our SPA
         * @returns {Promise} 
         */
        loadServerData: function () {
            this._sdPromise = this._sdPromise ||
                $.get('/api/layout/getserverdata')
                    .then(this.onServerDataLoadedHandler, this.onServerDataErrorHandler);
            return this._sdPromise;
        },

        onServerDataLoaded: function (serverData) {
            this.retryCount = 0;
            this._sdPromise = null; //set back to null, so we can recall this to get fresh--this enables us to throttle calls to load serverdata.
            if (utils.tryGetValue(window, 'ServerData.Settings') != null && window.ServerData.Settings.SiteVersion !== serverData.Settings.SiteVersion) {
                window.gaTrack('site', 'SPA-update', serverData.Settings.SiteVersion, 1);
                window.location.reload();
            }
            window.ServerData = serverData;
            document.dispatchEvent(new Event('serverDataLoaded'));
            this.setLayout();
            return serverData;
        },

        /**
         * if it fails, retry 3 times every second before giving up, but fail silently
         */
        onServerDataError: function (error) {
            this._sdPromise = null;
            if (this.retryCount < 3) {
                setTimeout(function () {
                    this.retryCount++;
                    this.loadServerData();
                }.bind(this), 1000);
            } else {
                console.error('Failed to load server data.');
                this.retryCount = 0;
            }
        },

        setMenu: function () {
            var data = {
                user: window.ServerData.user,
                /**
                 * Hide hotel/employer links if the user is or appears to be a member
                 * @returns {bool} 
                 */
                hideHotelAndEmployerInfoLinks: function () {
                    var user = window.ServerData.user;
                    var notInMultipleRoles = user == null || user.roles.length < 2;
                    var companyCookieSet = parseInt(window.CookieUtil.get('company')) > 0;
                    var isMember = user != null && userService.inRole('Member');
                    return notInMultipleRoles && (companyCookieSet || isMember);
                }
            };
            if (window.app.menu != null) {
                window.app.menu.reset(data);
            } else {
                var menuRactive = new Ractive({
                    el: 'layout-menu',
                    template: require('rv!templates/layout/menu'),
                    data: data
                });
                menuRactive.on({
                    /**
                     * Clear dba user at the server and update UI accordingly
                     * @param {RactiveEvent} e 
                     */
                    removeAltUser: function (e) {
                        e.original.preventDefault();
                        this.set('loading', true);
                        $.get('/api/users/RemoveAltUser').then(function (response) {
                            window.ServerData = response.newServerData;
                            var user = utils.tryGetValue(window, 'ServerData.user');
                            if (window.app.ribbon != null) {
                                window.app.ribbon.set('user', user);
                            }
                            window.app.menu.set('user', user);
                            window.location = response.searchPage;
                            //    window.app.controllerManager._loadController(window.app.controllerManager.currentController); //reload the current controller, since we've switched back to being us again.
                            this.set('loading', false);
                        }.bind(this), function (err) {
                            alert('Something went wrong clearing the alternate user');
                            this.set('loading', false);
                        }.bind(this));
                    },

                    adestinnIn90Seconds: function (e) {
                        e.original.preventDefault();
                        var hash = '#/about/?v=y';
                        if (window.location.hash === hash) {
                            $('#hidden_videoAnchor').first().trigger('click');
                        } else {
                            window.location.hash = hash;
                        }
                    }
                });
                window.app.menu = menuRactive;

                //hide menu item when it's clicked
                var submenus = $('.sub-menu');
                $('li', submenus).on('click', submenus.hide.bind(submenus));
            }
        },

        /**
         * Set completed steps, bank account verification/failure info, and vacation savings values
         * Note we hide the ribbons for callcenter if they aren't operating as a member. We also hide it if there are no completed steps--operating as a hotel
         * @returns {Ractive?} 
         */
        setRibbon: function () {
            var user = window.ServerData.user;
            if (user == null ||
                user.status == null ||
                user.status.completedSteps == null ||
                user.status.completedSteps.length === 0 ||
                (userService.inRole('CallCenter') && !user.isDba && !userService.inRole('Admin'))) {
                if (window.app.ribbon != null) {
                    window.app.ribbon.set('user', null);
                    this._removeGrayTop();
                }
                return null;
            }
            var onFinancialPage = /\/myaccount\/financialaccount\.aspx/i.test(window.location.toString());
            if (onFinancialPage &&
                (
                    user.status.accounts.ReadyForVerification > 0 ||
                    user.status.accounts.FailedTransactions > 0 ||
                    user.status.accounts.NotReadyForVerification > 0
                )
            ) {
                //if coming to the financial page to fix this stuff, don't bother showing it
                return null;
            }
            this._setGrayTop();
            var doneEnrolling = ![1, 2, 3, 4].some(function (s) {
                return !this._completedStep(s);
            }.bind(this));

            var data = {
                user: user,
                doneEnrolling: doneEnrolling,
                completedStep: this._completedStep
            };
            if (window.app.ribbon != null) {
                window.app.ribbon.reset(data);
            } else {
                window.app.ribbon = new Ractive({
                    el: 'layout-ribbon',
                    template: require('rv!templates/layout/ribbon'),
                    data: data
                });
            }
        },

        _setGrayTop: function () {
            $('#contentbox-top').attr('id', 'contentbox-top-grey');
            $('#contentbox').attr('id', 'contentbox-grey');
        },

        _removeGrayTop: function () {
            $('#contentbox-top-grey').attr('id', 'contentbox-top');
            $('#contentbox-grey').attr('id', 'contentbox');
        },

        /**
         * if the user has completed the step
         * @param {int} stepId 
         * @returns {bool} 
         */
        _completedStep: function (stepId) {
            var user = window.ServerData.user;
            return user != null && user.status.completedSteps.some(function (cs) {
                return stepId === cs;
            });
        },

        setFooter: function () {
            var data = {
                ServerData: window.ServerData,
                getYear: function () {
                    return new Date().getFullYear();
                }
            };
            if (window.app.footer != null) {
                window.app.footer.reset(data);
            } else {
                window.app.footer = new Ractive({
                    el: 'layout-footer',
                    template: require('rv!templates/layout/footer'),
                    data: data
                });
            }
        },

        /**
         * Set up event handlers for global elements
         * Note that we turn off handlers then turn them on, so this can be called multiple times to refresh as needed when dynamic content is loaded
         */
        initGlobalHandlers: function () {
            //main navigation
            $('#menu-nav').superfish({
                easing: 'easeOutExpo',
                delay: 0,
                animation: { opacity: 'show', height: 'show' }, // fade-in and slide-down animation 
                speed: 'fast', // faster animation speed 
                speedOut: 'normal',
                autoArrows: false, // disable generation of arrow mark-up 
                dropShadows: false, // disable drop shadows 
                disableHI: true //no hoverintent necessary--causes an annoying delay
            });

            //help popups
            $('.infoLink').fancybox({
                autoSize: true
            });

            //olark "chat with us" link
            $('.openOlark').off('click').on('click', olarkUtils.openChat);

            //google analytics trackers e.g. data-track="Category,Action,Label,Value"
            //note that we debounce it to handle for when checkbox labels are clicked and trigger two identical events...
            $('[data-track]').off('click').on('click', utils.debounce(function () {
                var params = $(this).attr('data-track').split(',');
                window.gaTrack.apply(window, params);
            }, 100));

            //placeholder polyfill
            if ($.placeholder != null) {
                console.log('placeholder...');
                $(':input[placeholder]').placeholder();
            }
        },

        /**
         * load optimizely if in production
         */
        setOptimizely: function () {
            if (window.ServerData.isProd) {
                require('controllers/retargetingpixel')();
            }
        },

        /**
         * load data into the layout's content area
         * @param {Promise} dataPromise 
         * @param {pre-compiled ractive template} template 
         * @returns {Ractive} 
         */
        initRactive: function (data, template, optionsOverrides) {
            var options = $.extend({
                el: this.content,
                template: template,
                data: data
            }, optionsOverrides);
            return new Ractive(options);
        },

        /**
         * Load a static html file into the layout's content area
         * Note that any error results in just going to 404
         * Note that we set the special 'loading' property so if 
         *      hash changes while the static template is loading, 
         *      the get request is aborted and we get the correct content
         * @param {string} path 
         * @param {int} version (optional) to tack onto file, so browser doesn't used cached version
         * @returns {Promise} 
         */
        initStatic: function (htmlFile) {
            var url = '{0}.html?v={1}'.format(htmlFile, window.ServerData.Settings.SiteVersion);
            var setHtml = this.content.html.bind(this.content);
            var instance = utils.tryGetValue(window, 'app.controllerManager.currentController.instance');
            if (instance != null) {
                instance.loading = $.get(url);
                return instance.loading.then(setHtml);
            }
            return $.get(url).then(setHtml);
        },

        /**
         * Indicate that a new controller is loading its 
         * steamy new data into the content area oh yeah
         * Note that this.content might be null if the user switches the hash prior to the page finishing loading
         */
        setLoading: function () {
            if (this.content == null) {
                return;
            }
            this.content
                .html('<div style="text-align:center;"><img style="margin-top:200px;height:120px;" src="https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" /></div>');
        },

        /**
         * pass an array of crumbs and they will be shown as bread crumbs below the ribbon.
         * @param {Array<{name,url}> crumbs 
         * @returns {Ractive} 
         */
        setBreadCrumbs: function (crumbs) {
            if (window.app.breadcrumbs == null) {
                window.app.breadcrumbs = new Ractive({
                    el: '#layout-breadcrumbs',
                    template: require('rv!templates/partials/breadcrumbs')
                });
            }
            window.app.breadcrumbs.set('breadcrumbs', crumbs);
        },

        /**
         * clear and teardown breadcrumbs if they exist
         */
        unsetBreadCrumbs: function () {
            if (window.app.breadcrumbs != null) {
                window.app.breadcrumbs.teardown();
                window.app.breadcrumbs = null;
            }
        },

        /**
         * if the user isn't in the passed in roles, and redirect to the login page.
         * @returns {bool} 
         */
        authorize: function (roles, callback) {
            if (userService.inRole(roles)) {
                callback();
            } else {
                this.setLoading();
                window.location = '/login.aspx?access=false&ReturnUrl={0}'.format(window.encodeURIComponent(window.location.toString()));
            }
    },

    /**
     * Centralized method to hide default match plan percentage if user has associated cookie
     * This helps fix grammar
     */
    hideMatchPlanTemplate: function () {
      let elementsToHide;

      if (
        window.ServerData.Settings.MatchPercentage.toLowerCase() == "default"
      ) {
        elementsToHide = document.querySelectorAll(".match-plan-percentage");
      } else {
        elementsToHide = document.querySelectorAll(".default-match-percentage");
      }

      elementsToHide.forEach((el) => {
        el.classList.add("hidden");
      });
    },
    };
});
